<template>
  <header class="border-b border-slate-200/40 z-20 mb-8">
    <nav class="mx-auto flex w-full max-w-[1280px] items-center justify-center py-2 px-4 sm:px-6 lg:px-8" aria-label="Global">
      <div class="flex w-full max-w-[964px] justify-center">
          <span class="sr-only">Hayrat Eğitim</span>
          <NuxtImg
            class="w-[60px] h-[58px] sm:w-[70px] sm:h-[68px] lg:w-[81px] lg:h-[79px] cursor-pointer hover:opacity-80 transition-opacity duration-200"
            src="/logo.webp"
            alt="Hayrat Eğitim Logo"
            format="webp"
            quality="75"
            width="81"
            height="79"
            @click="navigateTo('/')"
          />
      </div>
    </nav>
  </header>
</template>